import {
    Breadcrumb as AntdBreadcrumb,
} from 'antd';

interface Props {
    title: string,
    onClick: () => void
    history: AppStatusModal.Breadcrumb | undefined
    onClickPreviousBreadcrumb: (history: AppStatusModal.Breadcrumb) => void
}

export const Breadcrumb: React.FC<Props> = ({ title, onClick, history, onClickPreviousBreadcrumb }) => {
    return (
        <AntdBreadcrumb style={{ marginBottom: '1rem' }} separator='>'>
            <AntdBreadcrumb.Item>
                <button
                    className='text-button'
                    onClick={onClick}
                >
                    全員・すべての学習
                </button>
            </AntdBreadcrumb.Item>
            {history ? (
                <>
                    <AntdBreadcrumb.Item>
                        <button className='text-button' onClick={()=> onClickPreviousBreadcrumb(history)}>
                            {history.name}
                        </button>
                    </AntdBreadcrumb.Item>
                    <AntdBreadcrumb.Item>学習履歴</AntdBreadcrumb.Item>
                </>
            ) : (
                <AntdBreadcrumb.Item>{title}</AntdBreadcrumb.Item>
            )}
        </AntdBreadcrumb>
    );
};
